"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("../../config");
var USE_CASE_REPORT_TITLES = {
    SummaryReport: 'Details',
    UserJourneyReport: 'Journey',
    TechnologyReport: 'Technology',
    BudgetReport: 'Budget',
    MetricsReport: 'Metrics',
    AgentRoadmapReport: 'Roadmap',
};
var getFieldValue = function (fields, fieldNames) {
    for (var _i = 0, fieldNames_1 = fieldNames; _i < fieldNames_1.length; _i++) {
        var fieldName = fieldNames_1[_i];
        var value = fields[fieldName];
        if (value !== null && value !== undefined && ("" + value).trim()) {
            return "" + value;
        }
    }
    return null;
};
var getTargetSystemId = function (useCase) {
    var systemInformation = useCase.systemInformation;
    if (!systemInformation) {
        return null;
    }
    var targetSystem = Object.keys(systemInformation)
        .map(function (key) { return systemInformation[key]; })
        .find(function (item) { return item.type === 'target'; });
    return targetSystem ? targetSystem.id : null;
};
var mapUseCaseRecordToOutput = function (useCase) {
    return {
        ID: "" + useCase.id,
        AiUseCase: __assign(__assign({}, useCase), { description: useCase.description || null, workflow: useCase.workflow || null }),
        Version: 1,
        Draft: {
            ID: "" + useCase.id,
            TargetSystemID: getTargetSystemId(useCase),
            Title: useCase.title || null,
            Objective: getFieldValue(useCase.fields, ['Objective']),
            TargetAudience: getFieldValue(useCase.fields, ['TargetAudience']),
            TechnologyStack: getFieldValue(useCase.fields, ['TechnologyStack']),
            Timeline: null,
            NoOfUsersImpacted: getFieldValue(useCase.fields, ['NoOfUsersImpacted']),
            Priority: getFieldValue(useCase.fields, ['Priority', 'priority']),
            Impact: getFieldValue(useCase.fields, ['Impact']),
            PainPoint: getFieldValue(useCase.fields, ['PainPoint', 'PainPoints']),
            Process: getFieldValue(useCase.fields, ['Process']),
            Risk: getFieldValue(useCase.fields, ['Risk']),
            TimeSaving: getFieldValue(useCase.fields, ['TimeSaving']),
            UsageStats: getFieldValue(useCase.fields, ['UsageStats']),
            OtherInfo: getFieldValue(useCase.fields, ['OtherInfo']),
            UserName: getFieldValue(useCase.fields, ['OwnerName', 'Owner']),
            UserMail: getFieldValue(useCase.fields, ['OwnerEmailAddress']),
            CreatedAt: getFieldValue(useCase.fields, ['CreatedAt', 'createdAt', 'ModifiedAt', 'modifiedAt']) || '',
            Industries: getFieldValue(useCase.fields, ['Industries']),
            IsManual: false,
            WorkspaceId: '',
        },
        UseCaseResults: Object.keys(USE_CASE_REPORT_TITLES).map(function (reportKey, index) { return ({
            ID: '',
            Title: USE_CASE_REPORT_TITLES[reportKey],
            Text: "" + (useCase.fields[reportKey] || ''),
            Order: index,
            Model: '',
            Cost: '',
        }); }),
        IsComplete: true,
        TotalTokens: 0,
        TotalCost: '',
        Duration: 0,
        ReportPath: '',
        AgentPath: '',
        ChatSummaryPath: '',
        FilterScore: null,
        IsLoading: null,
    };
};
/**
 * API service for AI Hub use case report output.
 */
var aiHubUseCaseOutputApiService = {
    /**
     * Fetch use case details and adapt them to the dashboard detail payload.
     */
    getUseCaseOutput: function (useCaseId) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, config_1.getApiGet()("/ai/ukdc/use-cases/" + encodeURIComponent(useCaseId))];
                case 1:
                    result = (_a.sent());
                    return [2 /*return*/, result ? mapUseCaseRecordToOutput(result) : null];
                case 2:
                    error_1 = _a.sent();
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); },
};
exports.default = aiHubUseCaseOutputApiService;
